import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import Categories from 'containers/product-catalog/categories/Categories';
import { useAppSelector } from 'hooks';
import { FC } from 'react';

const CategoriesPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Categories" />;
  }
  return <Categories />;
};

export default CategoriesPage;
